(function () {
  const API = "/wp-json/wp/v2/work?acf_format=standard";
  let currentPage = 0;

  $(document).ready(() => {
    if ($(".project-filters").length === 0) return;

    checkQueryParams();

    $(".project-filters__head").on("click", toggleMobileFilters);
    $('.project-filters__term input[type="checkbox"]').on(
      "change",
      checkboxChanged
    );
    $(".projects-grid__btn").on("click", () => getProjects());

    getProjects(true);
  });

  function checkQueryParams() {
    var urlParams = new URLSearchParams(window.location.search);
    var expertiseId = urlParams.get("expertise");

    if (expertiseId) {
      $(`.project-filters__term [data-term-id="${expertiseId}"]`).prop(
        "checked",
        true
      );
    }
  }

  function toggleMobileFilters() {
    $(".project-filters").toggleClass("mobile-open");
    $(".project-filters__groups").slideToggle();
  }

  function checkboxChanged() {
    getProjects(true);
  }

  function getProjects(reset = false) {
    let newPage = reset ? 1 : currentPage + 1;

    let params = {
      per_page: 9,
      page: newPage,
      work_type: parseInt($(".projects-grid").attr("data-work-type")),
      ...getFilterParams(["sector", "expertise", "brand", "technology"]),
    };

    // clear
    if (reset) $(".projects-grid__items").html("");

    $(".projects-grid__main").addClass("loading");

    $.ajax(API, {
      data: params,
      success: (response, textStatus, XHR) => {
        if (!response) {
          $(".projects-grid__items").html(
            '<div class="projects-grid__msg">No work found.</div>'
          );
        } else {
          render(response, !reset);
        }

        // check if should show load more button
        const totalPages = parseInt(
          XHR.getResponseHeader("x-wp-totalpages"),
          10
        );
        if (currentPage >= totalPages) {
          $(".projects-grid__btn-wrap").hide();
        } else {
          $(".projects-grid__btn-wrap").show();
        }
      },
      error: () => {
        $(".projects-grid__items").html(
          '<div class="projects-grid__msg">There was a problem retrieving projects.</div>'
        );
        $(".projects-grid__btn-wrap").hide();
      },
      complete: () => {
        $(".projects-grid__main").removeClass("loading");
      },
    });

    currentPage = newPage;
  }

  function getFilterParams(filtersNames) {
    let filterParams = {};

    filtersNames.forEach((name) => {
      let $filters = $(`[data-group="${name}"] input[type="checkbox"]:checked`);
      let ids = $filters
        .map((_index, el) => el.getAttribute("data-term-id"))
        .get();
      if (ids.length > 0) filterParams[name] = ids.join(",");
    });

    return filterParams;
  }

  function render(posts, append = true) {
    let newMarkup = posts.map(
      (post) => `
			<a class="project-card" href="${post.link}">
				<div class="project-card__img">
					<div class="project-card__img-inner" style="background-image: url(${post.acf.thumbnail.sizes.medium});"></div>
				</div>
				<div class="project-card__info">
					<div class="project-card__title">${post.acf.short_title}</div>
					<div class="project-card__desc">${post.acf.short_description}</div>
				</div>
			</a>
		`
    );

    if (append) {
      $(".projects-grid__items").append(newMarkup);
    } else {
      $(".projects-grid__items").html(newMarkup);
    }
  }
})();
